module.exports = require("@pb/kit-component-label");